<template>
  <Navbar class="bg-BGcolor2 z-10" />
  <div class="flex flex-col h-screen w-full">
  <div class="flex flex-row sm:flex-col w-full px-8 pt-32">
      <div class="flex flex-col w-1/5 sm:w-full pt-20 sm:pt-0 space-y-8 mr-8 sm:mr-0 text-center">
        <div @click="$router.push('/lesson1')" class="flex ">
          <button class="flex flex-col focus:outline-none space-y-2 items-center w-full text-green-700 ">
          <p class="text-2.5xl 2xl:text-3xl sm:text-lg md:text-xl">LESSON 1</p>
          <p class="text-xl sm:text-base md:text-lg 2xl:text-2xl pb-1">Light</p>
          <hr class="opacity-50 w-full sm:w-3/5 h-0.5 border-2 border-green-700">
          </button>
        </div>
        <div @click="$router.push('/lesson2')" class="flex">
          <button class="flex flex-col focus:outline-none space-y-2 items-center w-full ">
          <p class="text-2.5xl 2xl:text-3xl sm:text-lg md:text-xl">LESSON 2</p>
          <p class="text-xl sm:text-base md:text-lg 2xl:text-2xl pb-1">Reflection of Light</p>
          <hr class="opacity-50 w-full sm:w-3/5 h-0.5 border-2 border-green-700">
          </button>
        </div>
        <div @click="$router.push('/lesson3')" class="flex">
          <button class="flex flex-col focus:outline-none space-y-2 items-center w-full ">
          <p class="text-2.5xl 2xl:text-3xl sm:text-lg md:text-xl">LESSON 3</p>
          <p class="text-xl sm:text-base md:text-lg 2xl:text-2xl  pb-1">Refraction of Light</p>
          <hr class="opacity-50 w-full sm:w-3/5 h-0.5 border-2 border-green-700">
          </button>
        </div>
        <div @click="$router.push('/lesson4')" class="flex">
          <button class="flex flex-col focus:outline-none space-y-2 items-center w-full ">
          <p class="text-2.5xl 2xl:text-3xl sm:text-lg md:text-xl">LESSON 4</p>
          <p class="text-xl sm:text-base 2xl:text-2xl md:text-lg pb-1">Dispersion of Light</p>
          <hr class="opacity-50 w-full sm:w-3/5 h-0.5 border-2 border-green-700">
          </button>
        </div>
      </div>
    
        <div class="flex flex-col w-4/5 space-y-8 sm:w-full sm:mt-20">
    <div class="w-4/5 sm:w-full mx-auto pb-11.5">
      <h1
        class="
          text-4xl
          sm:text-3xl
          2xl:text-5xl
          font-bold
          leading-normal
          text-center
        "
      >
        Nature of Light
      </h1>
    </div>
    <div class="pt-16 sm:pt-0">
      <div
      class="bg-white w-100 sm:w-72 h-auto shadow border mx-auto border-black"
    >
    <div class="flex flex-col leading-loose justify-center px-12 py-8 space-y-6 sm:px-6 sm:py-4 sm:space-y-3">
      <p class=" font-bold text-xl sm:text-lg text-center">TABLE OF CONTENTS</p>
      <div class="flex flex-col text-lg sm:text-base">
        <p class="font-bold ">Introduction: Nature of Light</p>
        <ul class="list-disc pl-5">
          <li>Brief History of Light</li>
          <li>Properties and Characteristics of Light</li>
        </ul>
      </div>
      <div class="flex flex-col text-lg pb-5 sm:text-base">
        <p class="font-bold ">Visible</p>
        <ul class="list-disc pl-5">
          <li>Frequency and Wavelength</li>
          <li>Electromagnetic Spectrum</li>
          <li>Properties of Light</li>
        </ul>
      </div>
    </div>
    </div>
    </div>
    <div class="flex flex-col space-y-8 p-4 leading-loose text-justify">
      <h2 class="text-4xl sm:text-3xl 2xl:text-5xl font-bold">BRIEF HISTORY</h2>
      <p class="text-lg sm:text-base 2xl:text-xl">
        <span class="pl-9">Light</span> had been one of the wonders of the
        greatest philosophers before, it required hundreds of years to discover
        what we know today. Optics is known as the oldest discipline in the
        field of physics. At 5th B.C .to 3rd B.C. Socrates, Plato and
        Aristotle’s philosophies serve as the foundation to build Optics.
        However Euclid (330-275 B.C) summarized the essential knowledge of
        Optics including reflection, diffusion and vision and turn it to a book
        entitled “Optics”, in this old ages the concept was that the essence of
        light is white light and colors are created from the mixture of
        lightness and darkness, the exploration of light continue when Ibn
        al-Haytham (Alhazen) (965-1040) conducted a more precise theory through
        mathematical and experimental method which are ompiled into his book
        entitled “The book of Optics” , his works serve as the driving force for
        modern science. In 1672 the concept of light of Aristotle about light
        was opposed by the discovery of Isaac Newton, he claimed that rather
        than pure white light (sunlight), the light is a combination of various
        colors having different refractivity (New Theory on Light and color) and
        in 1704 he authored the book named “Opticks” where he reveals the “Light
        Particle Theory”. At 1690 Christian Huygens published a paper on light
        promoting that light is a wave which explain the reflection and
        refraction phenomena of light contradicting Newton’s light particle
        theory, Huygens theory was supported by Thomas Young by his pinhole
        experiment and advocated that light behave like a wave, Young was also
        the first person to use the term energy and introduce his concept. At
        twentieth a century groundbreaking research papers made by Albert
        Einstein unraveled a theory that light is made up of particles called
        photon.<br /><br /><span class="pl-9">The</span> experiments made by
        well-known geniuses help us to understand the properties and
        characteristic of light, from reflection, refraction, and dispersion.
      </p>
    </div>
    <div class="flex flex-col space-y-8 p-4 leading-loose text-justify">
      <h2 class="text-4xl sm:text-3xl 2xl:text-5xl font-bold">VISIBLE LIGHT</h2>
      <p class="text-lg sm:text-base 2xl:text-xl">
        <span class="pl-9">Light</span> is an energy form. The Sun is a
        significant light energy source. There would be no plants or animals on
        the surface of the Earth if the Sun did not provide energy. In an experiment known as Young's Interference Experiment, an English physicist named Thomas Young stated that light possesses wave qualities in 1807. Lights (waves) travelling through two slits (double-slit) add together or cancel each other, resulting in interference fringes, according to Young's experiment. This phenomenon cannot be explained unless light is considered as a wave. On the other hand, Albert Einstein was a physicist who were able to describe the photoelectric effect, which had previously been unfathomable when light was simply considered as a wave. Light, according to Einstein, is a particle with energy proportional to its wavelength. So, light in this way came to be called “photons (light quanta)” since it has the properties not only of a wave but also of a particle.
      </p>
    </div>
    <div class="flex flex-col space-y-8 p-4 leading-loose text-justify">
      <h2 class="text-4xl sm:text-3xl 2xl:text-5xl font-bold">
        Frequency and Wavelength
      </h2>
      <p class="text-lg sm:text-base 2xl:text-xl">
        <span class="pl-9">One</span> of the known features of light is that it
        behaves like a wave. As a result, the wavelength and frequency of light
        are used to characterize it. The frequency of a wave is the pace at
        which it vibrates or rises and falls while the wavelength is the
        distance between two peaks. Frequency and wavelength are inversely
        proportional which means the higher the frequency the shorter the
        wavelength and vise-versa.
      </p>
      <div class="flex justify-center">
        <img
          src="../assets/imgs/lesson1/1.png"
          class="w-9/12 2xl:w-7/12 h-auto"
        />
      </div>
      <p class="text-lg sm:text-base">
        <span class="pl-9">We</span> can only see light that falls inside a
        specified wavelength and frequency range. The visible spectrum refers to
        this range. The visible spectrum has a frequency range of 405 Terahertz
        to 790 terahertz.
      </p>
    </div>
    <div class="flex flex-col space-y-8 p-4 leading-loose">
      <h2 class="text-4xl sm:text-3xl 2xl:text-5xl font-bold">
        The Electromagnetic Spectrum
      </h2>
      <p class="text-lg sm:text-base 2xl:text-xl text-justify">
        <span class="pl-9">The</span> electromagnetic spectrum encompasses a
        wide range of light wavelengths, some of which are invisible to the
        naked eye. Radio waves, microwaves, infrared rays, and x-rays are
        examples of non- visible waves. These waves have a wide range of
        application in research and technology. The color of light in the
        visible spectrum is determined by its frequency.
      </p>
      <div class="flex justify-center ">
        <img
          src="../assets/imgs/lesson1/2.png"
          class="w-9/12 2xl:w-7/12 h-auto"
        />
      </div>
      <p class="italic text-lg text-black text-center">Figure 1: Electromagnetic Spectrum</p>
    </div>
    <div class="flex flex-col space-y-8 p-4 leading-loose text-justify">
      <h2 class="text-4xl sm:text-3xl 2xl:text-5xl font-bold">
        Properties of Light
      </h2>
      <p class="text-lg sm:text-base 2xl:text-xl">
        <span class="pl-9">Ever</span> wondered how rainbows are formed and why
        does the image reflect by an object is clear and sometime not? Well, we
        will about explore how these things are possible by understanding what
        reflection, refraction and dispersion are.<br /><br /><br />This topic
        will be discussed in lesson 2, lesson 3 and lesson 4.
      </p>

      <div class="space-y-8 ">
        <p class="text-4xl sm:text-3xl 2xl:text-5xl mt-14 sm:mt-10 md:mt-12">REFERENCES</p>
        <div class="flex flex-col space-y-5 leading-5 text-lg sm:text-base 2xl:text-xl">
        <p>[1] Encyclopedia Britannica. 2022. electromagnetic spectrum | Definition, Diagram, & Uses. [online] Available at: <a href="https://www.britannica.com/science/electromagnetic-spectrum" class="break-all">&lt;https://www.britannica.com/science/electromagnetic-spectrum&gt;</a> [Accessed 27 March 2022].</p>
        <p>[2] Photon Tearrace, “History of Research of light,Hamamatsu”, doi: https://photonterrace.net/en/photon/history</p>
        <p>[3] Saratogaschools.org. 2022. Light Waves Notes. [online] Available at: <a href="https://www.saratogaschools.org/webpages/tsanders/notes.cfm?subpage=1384475#:~:text=A%20light%20wave%20is%20an,an%20enormous%20range%20of%20frequencies" class="break-all">&lt;https://www.saratogaschools.org/webpages/tsanders/notes.cfm?subpage=1384475#:~:text=A%20light%20wave%20is%20an,an%20enormous%20range%20of%20frequencies.&gt;</a> [Accessed 27 March 2022].</p>
        <p>[4] The Law of Reflection, Lumen physics, doi: https://courses.lumenlearning.com/physics/chapter/25-2-the-law-of-reflection/ </p>
        <p>[5] The wave-particle dualiy of photons.Photon Terrace. (n.d.) retrieved March, 2022, from https://photonterrace. net/en/phton/duality/</p>
        </div>
      </div>
    </div>
  </div>
  </div>
  <Footer/>
  </div>
</template>

<script>
import Navbar from "@/views/nav"
import Footer from "@/views/footer"
  export default {
    data() {
      return {

      };
    },

    components: {
      Navbar,
      Footer,
    },

    methods: {

    },
};
</script>

<style scoped>

</style>